import services from '../../../services'

const state = {
}

const actions = {
  async applicationList ({commit}, query) {
    return await services.application_query(query)
  },
  async updateApplicationData ({commit}, options) {
    return await services.application_update(options._id, options)
  }
}

const mutations = {
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/application.js